import { Github, Linkedin, Mail } from "lucide-react";
import { profile } from "../data/portfolio";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 mt-16"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="font-mono text-xs tracking-widest text-purple-400 uppercase">
            {"< / >"} designed & built with care
          </div>
          <div className="mt-2 text-white/60 text-sm">
            © {new Date().getFullYear()} Riya Gupta — All rights reserved.
          </div>
        </div>

        <div className="flex items-center gap-3">
          <a
            data-testid="footer-github"
            aria-label="GitHub"
            href={profile.github}
            target="_blank"
            rel="noreferrer"
            className="w-10 h-10 rounded-md border border-white/10 flex items-center justify-center text-white/70 hover:text-purple-300 hover:border-purple-500/40 transition-colors"
          >
            <Github size={16} />
          </a>
          <a
            data-testid="footer-linkedin"
            aria-label="LinkedIn"
            href={profile.linkedin}
            target="_blank"
            rel="noreferrer"
            className="w-10 h-10 rounded-md border border-white/10 flex items-center justify-center text-white/70 hover:text-purple-300 hover:border-purple-500/40 transition-colors"
          >
            <Linkedin size={16} />
          </a>
          <a
            data-testid="footer-email"
            aria-label="Email"
            href={`mailto:${profile.email}`}
            className="w-10 h-10 rounded-md border border-white/10 flex items-center justify-center text-white/70 hover:text-purple-300 hover:border-purple-500/40 transition-colors"
          >
            <Mail size={16} />
          </a>
        </div>
      </div>
    </footer>
  );
};
